import React from "react";
import styled from "styled-components";

const TagStatus = ({ className, text }) => {
  return (
    <span className={className}>
      <div className="__contain">
        {text}
        <div className="__contain__ear" />
      </div>
    </span>
  );
};

export default styled(TagStatus)`
  position: absolute;
  right: -20px;

  .__contain {
    background: ${(props) => props.backgroundColor};
    width: 188px;
    padding: 7px 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px 0 0 4px;
    font-weight: 600;
    font-size: 15px;
    color: #fff;

    .__contain__ear {
      bottom: -12px;
      right: 0;
      width: 0;
      height: 0;
      border-top: 12px solid ${(props) => props.backgroundColor}BF;

      border-right: 21px solid transparent;
      position: absolute;
      background: transparent;
    }
  }
`;
